<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import Fa from 'svelte-fa'
    import { faLink, faRefresh, faTrash, faUnlink } from '@fortawesome/free-solid-svg-icons'
    import type { Account } from '../../modules/financialApi/accounts/account'
    const dispatch = createEventDispatcher()

    export let accountId
    export let pluggyId
    export let showTrash = true
    export let showRefresh = true
    export const refresh = async () => {
        await connectAccount()
    }

    let pluggyConnect

    async function disconnectAccount() {
        if (!confirm('Deseja mesmo desconectar de sua conta bancária?')) return
        await window.api.financials.accounts.integrationUnlink(accountId)
        console.log('disconnected')
        dispatch('disconnected')
    }

    async function connectAccount() {
        // 1. carrega a conta para configurar o plugin pluggy
        const account: Account = await window.api.financials.accounts.getOne(accountId)
        console.log('getting token for accountId ' + accountId + '. PluggyId ' + account.pluggyId)

        // 2. pega um token de conexão para o plugin pluggy
        let response: { accessToken: string } = null
        try {
            response = await window.api.financials.accounts.getIntegrationToken(account.accountId, account.pluggyId)
            if (!response?.accessToken) {
                window.alert(
                    'Ops! Não foi possível atualizar sua conta no momento.\nSe este erro persistir informe ao suporte o erro [account-integration-error-001]',
                )
                console.log('response', response)
                return
            }
        } catch (error) {
            window.alert('Ops! Erro ao tentar conexão via Open Finance.\nPor favor, tente novamemente dentro de alguns instantes.')
            return
        }

        // 3. inicia o plugin com as configurações necessárias
        // @ts-ignore
        window.$.pluggyConnect = new PluggyConnect({
            products: ['ACCOUNTS', 'TRANSACTIONS'],
            connectToken: response.accessToken,
            updateItem: pluggyId || undefined,
            includeSandbox: false,
            onSuccess: pluggySuccess,
            onError: pluggyError,
        })
        window.$.pluggyConnect.init()
    }

    let pluggySuccess = async (itemData) => {
        console.log('Pluggy connect success!', itemData)
        await window.api.financials.accounts.integrationLink(accountId, itemData.item.id)
        pluggyId = itemData.item.id
        window.$.pluggyConnect.destroy()
        window.$.pluggyConnect = null
        dispatch('connected')
    }

    let pluggyError = async (error) => {
        window.$.pluggyConnect.destroy()
        window.$.pluggyConnect = null
        if (error.data?.item?.error?.code === 'USER_AUTHORIZATION_PENDING') {
            await window.api.financials.accounts.integrationLink(accountId, error.data?.item?.id)
            window.alert(
                'Concluído.\nAgora você precisa autorizar o acesso através de seu aplicativo do banco.\n\n' + (error.data?.item?.error?.providerMessage || '-'),
            )
            // dispatch('connected', error.data?.item?.id) // mesmo não tendo conectado, o id já é conhecido.
            return
        }
        window.log('Pluggy connect error', 'error', { error })
        window.alert('Ops! Não foi possível atualizar sua conta no momento.\nSe este erro persistir informe ao suporte o erro [account-integration-error-002]')
    }

    onMount(async () => {
        console.log('pluggyId', pluggyId)
    })
</script>

{#if !pluggyId}
    <button on:click={connectAccount} class="btn btn-secondary btn-sm"><Fa icon={faLink} /> Conectar conta</button>
{:else}
    {#if showTrash}
        <button on:click={disconnectAccount} class="btn btn-warning btn-sm"><Fa icon={faUnlink} /> Desconectar</button>
    {/if}
    {#if showRefresh}
        <button on:click={connectAccount} class="btn btn-secondary btn-sm"><Fa icon={faRefresh} /> Atualizar conta</button>
    {/if}
{/if}
